import { forwardRef } from "react";
import { CommonMapProvider } from "../contexts/CommonMapContext";

export function withCommonMapProvider(Component) {
  return forwardRef(function CommonMapWrapper(props, ref) {
    return (
      <CommonMapProvider>
        <Component {...props} ref={ref} />
      </CommonMapProvider>
    );
  });
}

/*
const Wrapper = forwardRef(function Wrapper({ children, inject, ...rest }, ref) {
  return cloneElement(children, {
    ...rest,
    ...inject,
    ref,
  });
});
*/
